"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = void 0;
const React = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const context_1 = require("components/context");
const modal_1 = require("components/modal");
const AddProducts_1 = require("components/partial/AddProducts");
const Clients_1 = require("components/partial/Clients");
const theme_1 = __importStar(require("theme"));
const url_1 = require("utils/url");
const icons_1 = __importDefault(require("constants/icons"));
const constants_1 = require("constants/constants");
const services_1 = require("services");
const native_1 = require("@react-navigation/native");
const NewQuote_1 = require("types/components/partial/NewQuote");
const ModalSelectWarehouseRV_1 = __importDefault(require("components/modal/ModalSelectWarehouseRV"));
const FullScreenLoad_1 = __importDefault(require("components/custom/FullScreenLoad"));
const NewQuote = ({ route, navigation }) => {
    const { client: clientParam, clientName: clientNameParams, clientType: clientTypeParam, warehouse: warehouseParam, } = route?.params ?? {};
    console.log("render! NewQuote", clientTypeParam);
    const authContext = React.useContext(context_1.AuthContext);
    const existentClientChanged = React.useRef(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [client, setClient] = React.useState(clientParam);
    const [clientType, setClientType] = React.useState(clientTypeParam ?? NewQuote_1.EClientType.CLIENT_NEW);
    /*useFocusEffect(
        React.useCallback(() => {
            navigation.setParams({
                clientType: clientType as EClientType,
            });
        }, [clientType]),
    );*/
    const [newWarehouseSN, setNewWarehouseSN] = React.useState(authContext?.loginData?.uidtipo == "SN" ? warehouseParam : undefined); //sn
    const [newWarehouseRV, setNewWarehouseRV] = React.useState(authContext?.loginData?.uidtipo == "RV" && clientType == NewQuote_1.EClientType.CLIENT_NEW ? warehouseParam : undefined); //rv
    const [existentWarehouseRV, setExistentWarehouseRV] = React.useState(authContext?.loginData?.uidtipo == "RV" && clientType == NewQuote_1.EClientType.CLIENT_EXISTENT
        ? warehouseParam
        : undefined); //rv
    const isNewRV = () => {
        const t1 = authContext?.loginData?.uidtipo == "RV";
        const t2 = newQuoteContext?.clientType == NewQuote_1.EClientType.CLIENT_NEW;
        return t1 && t2;
    };
    const newQuoteContext = React.useMemo(() => {
        return {
            cliidForCatalog: clientType == NewQuote_1.EClientType.CLIENT_EXISTENT ? client?.id : "", //usado actualmente en catalogo cotizacion
            cliid: clientType == NewQuote_1.EClientType.CLIENT_EXISTENT ? client?.id ?? "" : authContext?.loginData?.uid,
            clientType: clientType,
            //
            client: client,
            setClient: setClient,
            existentWarehouse: existentWarehouseRV,
            isNewRV: isNewRV,
        };
    }, [client?.id, clientType, existentWarehouseRV?.codigo]);
    const [newClientName, setNewClientName] = React.useState(clientNameParams ?? "");
    const [shoppingCartResponse, setShoppingCartResponse] = React.useState(null);
    const listShoppingCart = async () => {
        const onSuccess = (response) => {
            setShoppingCartResponse(response);
        };
        console.log(newQuoteContext);
        if (newQuoteContext.cliid) {
            const warehouseCode = newQuoteContext?.isNewRV() == true
                ? `${newWarehouseRV?.docentry ?? ""}-${newWarehouseRV?.lineid ?? ""}`
                : newQuoteContext.clientType == NewQuote_1.EClientType.CLIENT_NEW
                    ? newWarehouseSN?.codigo
                    : existentWarehouseRV?.codigo;
            if (warehouseCode == null || warehouseCode == "")
                return;
            (0, services_1.doCarritoCotiList)({
                params: {
                    clientId: newQuoteContext?.cliid,
                    almacen: newQuoteContext?.isNewRV() == true
                        ? `${newWarehouseRV?.docentry ?? ""}-${newWarehouseRV?.lineid ?? ""}`
                        : warehouseCode,
                    tipo: newQuoteContext?.isNewRV() == true ? "cotirvmt" : "coti",
                },
                callback: {
                    onSuccess,
                },
            });
        }
        else {
            setShoppingCartResponse(null);
        }
    };
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        if (existentClientChanged.current) {
            existentClientChanged.current = false;
            return;
        }
        listShoppingCart();
    }, [newQuoteContext?.clientType, newWarehouseSN?.codigo, newWarehouseRV?.codigo, existentWarehouseRV?.codigo]));
    React.useEffect(() => {
        console.log("!!!!!Se ha cambiado de tipo", "clientNameParams:", clientNameParams, "clientTypeParam", clientTypeParam, "warehouseParam", warehouseParam, "clientParam", clientParam);
        if (clientParam) {
            existentClientChanged.current = true;
            setShoppingCartResponse(undefined);
            setClient(clientParam);
        }
        if (clientNameParams)
            setNewClientName(clientNameParams ?? "");
        if (warehouseParam) {
            setNewWarehouseSN(authContext?.loginData?.uidtipo == "SN" ? warehouseParam : undefined);
            setNewWarehouseRV(authContext?.loginData?.uidtipo == "RV" && clientType == NewQuote_1.EClientType.CLIENT_NEW
                ? warehouseParam
                : undefined);
            setExistentWarehouseRV(authContext?.loginData?.uidtipo == "RV" && clientType == NewQuote_1.EClientType.CLIENT_EXISTENT
                ? warehouseParam
                : undefined);
        }
        if (clientNameParams)
            setClientType(clientTypeParam);
    }, [clientTypeParam, clientParam?.id, warehouseParam?.codigo, clientNameParams]);
    return (<>
			<context_1.NewQuoteContext.Provider value={newQuoteContext}>
				<native_base_1.ScrollView style={styles.svContainer} contentContainerStyle={styles.svContainerContent}>
					<native_base_1.View style={styles.layoutContainer} px={{ base: 20, md: 30 }} py={{ base: 20 }}>
						<BoxData client={client} warehouse={clientType == NewQuote_1.EClientType.CLIENT_NEW ? newWarehouseSN : existentWarehouseRV} warehouseRV={newWarehouseRV} setWarehouse={clientType == NewQuote_1.EClientType.CLIENT_NEW ? setNewWarehouseSN : setExistentWarehouseRV} setWarehouseRV={setNewWarehouseRV} shoppingCartResponse={shoppingCartResponse} newClientName={newClientName} setNewClientName={setNewClientName} setClientType={setClientType} listShoppingCart={listShoppingCart} setShoppingCartResponse={setShoppingCartResponse}/>
						<LayoutPrices shoppingCartResponse={shoppingCartResponse} client={client} newClientName={newClientName} setNewClientName={setNewClientName} listShoppingCart={listShoppingCart} setShoppingCartResponse={setShoppingCartResponse} setWarehouse={clientType == NewQuote_1.EClientType.CLIENT_NEW
            ? authContext?.loginData?.uidtipo == "RV"
                ? setNewWarehouseRV
                : setNewWarehouseSN
            : setExistentWarehouseRV} warehouseRV={newWarehouseRV} setIsLoading={setIsLoading}/>
					</native_base_1.View>
				</native_base_1.ScrollView>
			</context_1.NewQuoteContext.Provider>
			<FullScreenLoad_1.default isVisible={isLoading}/>
		</>);
};
const BoxData = ({ client, shoppingCartResponse, setShoppingCartResponse, warehouse, warehouseRV, setWarehouse, setWarehouseRV, newClientName, setNewClientName, setClientType, listShoppingCart, }) => {
    const navigation = (0, native_1.useNavigation)();
    const newQuoteContext = React.useContext(context_1.NewQuoteContext);
    const toast = (0, native_base_1.useToast)();
    const authContext = React.useContext(context_1.AuthContext);
    const changeWarehouse = (warehouse) => {
        listShoppingCart();
        setWarehouse(warehouse);
    };
    const changeWarehouseRV = (warehouse) => {
        listShoppingCart();
        setWarehouseRV(warehouse);
    };
    const onAddProductClick = () => {
        if (newQuoteContext?.clientType == NewQuote_1.EClientType.CLIENT_EXISTENT && client == null) {
            toast.show({
                description: "Debe seleccionar un cliente",
            });
            return;
        }
        if (newQuoteContext?.isNewRV() == true) {
            if (warehouseRV == null) {
                toast.show({
                    description: "Debe seleccionar un almacen",
                });
                return;
            }
        }
        else {
            if (warehouse == null) {
                toast.show({
                    description: "Debe seleccionar un almacen",
                });
                return;
            }
        }
        navigation.navigate(AddProducts_1.name, {
            warehouseCode: newQuoteContext?.isNewRV() == true ? warehouseRV?.codigo : warehouse?.codigo,
            cliid: newQuoteContext?.cliid,
            cliidForCatalog: newQuoteContext?.cliidForCatalog,
            docEntry: newQuoteContext?.isNewRV() == true ? warehouseRV?.docentry : undefined,
            lineId: newQuoteContext?.isNewRV() == true ? warehouseRV?.lineid : undefined,
        });
    };
    const deleteProduct = React.useCallback((product) => {
        const onSuccess = (response) => {
            listShoppingCart();
        };
        (0, services_1.doCarritoCotiRemove)({
            params: {
                clientId: newQuoteContext?.cliid,
                almacen: newQuoteContext?.isNewRV() == true
                    ? `${warehouseRV?.docentry ?? ""}-${warehouseRV?.lineid ?? ""}`
                    : warehouse?.codigo,
                tipo: newQuoteContext?.isNewRV() == true ? "cotirvmt" : "coti",
                data: {
                    procodigo: product?.codigo,
                },
            },
            callback: {
                onSuccess: onSuccess,
            },
        });
    }, [warehouse?.codigo, warehouseRV?.docentry, warehouseRV?.lineid]);
    const timeoutIdPrice = React.useRef(undefined);
    const updateProductPrice = React.useCallback((newPrice, product) => {
        clearTimeout(timeoutIdPrice.current);
        const callCarritoCotiPrice = () => {
            const onSuccess = (response) => {
                listShoppingCart();
            };
            (0, services_1.doCarritoCotiPrice)({
                params: {
                    data: {
                        procodigo: product?.codigo,
                        precio: newPrice,
                    },
                    cliid: newQuoteContext?.cliid,
                    almacen: newQuoteContext?.isNewRV() == true
                        ? `${warehouseRV?.docentry ?? ""}-${warehouseRV?.lineid ?? ""}`
                        : warehouse?.codigo,
                    tipo: newQuoteContext?.isNewRV() == true ? "cotirvmt" : "coti",
                },
                callback: {
                    onSuccess: onSuccess,
                },
            });
        };
        timeoutIdPrice.current = setTimeout(callCarritoCotiPrice, 1000);
    }, [warehouse?.codigo]);
    const timeoutIdSize = React.useRef(undefined);
    const updateProductSize = React.useCallback((newSize, product) => {
        clearTimeout(timeoutIdSize.current);
        const callCarritoCotiAdd = () => {
            const onSuccess = (response) => {
                listShoppingCart();
            };
            (0, services_1.doCarritoCotiAdd)({
                params: {
                    clientId: newQuoteContext?.cliid,
                    almacen: newQuoteContext?.isNewRV() == true
                        ? `${warehouseRV?.docentry ?? ""}-${warehouseRV?.lineid ?? ""}`
                        : warehouse?.codigo,
                    tipo: newQuoteContext?.isNewRV() == true ? "cotirvmt" : "coti",
                    data: {
                        procodigo: product?.codigo,
                        cantidad: newSize,
                        stockAlert: product.stockAlert,
                        stockAlertFecha: product.stockAlertFecha,
                        stockAlertReason: product.stockAlertReason,
                        stockAlertReasonType: product.stockAlertReasonType,
                        stockAlertColor: product.stockAlertColor,
                    },
                },
                callback: {
                    onSuccess: onSuccess,
                },
            });
        };
        timeoutIdSize.current = setTimeout(callCarritoCotiAdd, 1000);
    }, [warehouse?.codigo, warehouseRV?.docentry, warehouseRV?.lineid]);
    const renderItem = ({ item }) => (<Product product={item} deleteProduct={deleteProduct} updateProductPrice={newPrice => {
            updateProductPrice(newPrice, item);
        }} updateProductSize={newSize => {
            updateProductSize(newSize, item);
        }}/>);
    return (<native_base_1.VStack style={styles.boxQuote} minWidth={{ base: "100%", md: "md" }} p={{ base: 15, md: 25 }}>
			<SelectClientModal client={client} setClientType={setClientType} newClientName={newClientName} setNewClientName={setNewClientName} setShoppingCartResponse={setShoppingCartResponse}/>
			<SelectNewWarehouseModal warehouse={warehouse} warehouseRV={warehouseRV} changeWarehouseRV={changeWarehouseRV} changeWarehouse={changeWarehouse}/>
			<native_base_1.View style={styles.layoutProducts}>
				<native_base_1.Text style={[styles.txtProducts]} variant="h23">
					{shoppingCartResponse?.totalItems
            ? theme_1.Str.products + ` (${shoppingCartResponse?.totalItems ?? ""})`
            : theme_1.Str.products}
				</native_base_1.Text>
				<native_base_1.Button onPress={onAddProductClick} style={[styles.btnAddProduct]} startIcon={<native_base_1.Image source={require("images/ic_plus")} variant="iconButtonRightSm" alt={theme_1.Str.alt.ic_plus} style={{ tintColor: theme_1.Colors.colorBtnSecondaryIcon }}/>} colorScheme={theme_1.Colors.btnSecondary.name} _text={{
            color: theme_1.Colors.colorBtnSecondaryText,
        }} size="sm">
					Añadir
				</native_base_1.Button>
			</native_base_1.View>

			<native_base_1.FlatList data={shoppingCartResponse?.data} renderItem={renderItem}/>
			<AddDiscount isVisible={newQuoteContext?.clientType != NewQuote_1.EClientType.CLIENT_EXISTENT} warehouse={warehouse} warehouseRV={warehouseRV} discounts={shoppingCartResponse?.lineas} listShoppingCart={listShoppingCart}/>
		</native_base_1.VStack>);
};
const SelectClientModal = ({ setClientType, client, newClientName, setNewClientName, setShoppingCartResponse, }) => {
    const navigation = (0, native_1.useNavigation)();
    const authContext = React.useContext(context_1.AuthContext);
    const newQuoteContext = React.useContext(context_1.NewQuoteContext);
    const [showModal, setShowModal] = React.useState(false);
    const onClientChange = (clientName) => {
        setNewClientName(clientName);
    };
    let clienComponent;
    if (newQuoteContext?.clientType == NewQuote_1.EClientType.CLIENT_EXISTENT) {
        clienComponent = (<native_base_1.Pressable onPress={() => {
                navigation.navigate(Clients_1.name, {
                    origin: "NewQuote",
                });
            }} style={[styles.inputBoxQuote]} justifyContent="center" alignItems="center" mt="20" flexDir="row">
				<native_base_1.Text flex="1">{client?.nombre}</native_base_1.Text>
				<native_base_1.Image source={icons_1.default.icSearch} variant="iconButtonRight" color="#000000" style={{ tintColor: theme_1.Colors.colorTextPrimary }}/>
			</native_base_1.Pressable>);
    }
    else {
        clienComponent = (<native_base_1.Input style={[styles.inputBoxQuote]} justifyContent="center" mt="20" value={newClientName} onChangeText={onClientChange}/>);
    }
    const onClientTypeChange = (clientType) => {
        //limpiar el carrito al cambiar de cliente
        setShoppingCartResponse(undefined);
        setClientType(clientType);
    };
    return (<>
			<modal_1.ModalSelectClient isOpen={showModal} onClose={() => setShowModal(false)} onSelectedClient={(client) => {
            //setClient(client);
            setShowModal(false);
        }}/>
			<native_base_1.VStack>
				<native_base_1.HStack alignItems="center">
					<native_base_1.Text style={[styles.txtClient]} variant="h23">
						Cliente
					</native_base_1.Text>
					<native_base_1.Radio.Group display={authContext?.loginData?.uidtipo == constants_1.UserType.RV ? "flex" : "none"} name="clientType" value={newQuoteContext?.clientType} onChange={onClientTypeChange} flexDirection="row">
						<native_base_1.Radio value={NewQuote_1.EClientType.CLIENT_NEW}>{theme_1.Str.new}</native_base_1.Radio>
						<native_base_1.Radio value={NewQuote_1.EClientType.CLIENT_EXISTENT} ml="10">
							{constants_1.UserType.SN}
						</native_base_1.Radio>
					</native_base_1.Radio.Group>
				</native_base_1.HStack>
				{clienComponent}
			</native_base_1.VStack>
		</>);
};
//new
const SelectNewWarehouseModal = ({ changeWarehouse, changeWarehouseRV, warehouse, warehouseRV, }) => {
    const authContext = React.useContext(context_1.AuthContext);
    const newQuoteContext = React.useContext(context_1.NewQuoteContext);
    //const requestFn = React.useRef<() => void | undefined>();
    const modalRef = React.createRef();
    const [showModal, setShowModal] = React.useState(false);
    const [availableWarehouses, setAvailableWarehouses] = React.useState();
    const onFirstWarehouseObtained = (firstWarehouse) => {
        //if (authContext?.loginData?.uidtipo == UserType.SN) {
        if (warehouse == undefined && firstWarehouse)
            changeWarehouse(firstWarehouse);
        //}
    };
    return (<>
			{authContext?.loginData?.uidtipo == "RV" && newQuoteContext?.clientType == NewQuote_1.EClientType.CLIENT_NEW ? (<ModalSelectWarehouseRV_1.default isOpen={showModal} onClose={() => setShowModal(false)} onConfirmPress={(warehouse) => {
                changeWarehouseRV(warehouse);
                setShowModal(false);
            }}/>) : (<modal_1.ModalSelectWarehouse ref={modalRef} isOpen={showModal} onClose={() => setShowModal(false)} onConfirmPress={(warehouse) => {
                changeWarehouse(warehouse);
                setShowModal(false);
            }} onFirstWarehouseObtained={onFirstWarehouseObtained} onAvailableWarehouses={setAvailableWarehouses}/>)}

			<native_base_1.VStack display={authContext?.loginData?.uidtipo == "SN" &&
            newQuoteContext?.clientType == NewQuote_1.EClientType.CLIENT_NEW &&
            availableWarehouses?.length == 1
            ? "none"
            : "flex"}>
				<native_base_1.Text style={[styles.txtStock]} variant="h23">
					{theme_1.Str.warehouse}
				</native_base_1.Text>
				<native_base_1.Pressable onPress={() => {
            if (newQuoteContext?.clientType == NewQuote_1.EClientType.CLIENT_EXISTENT &&
                newQuoteContext?.client == null) {
                return;
            }
            setShowModal(true);
            modalRef.current?.onOpen();
            /*console.log(requestFn);
            if (requestFn) {
                console.log(requestFn);
                requestFn.current?.();
            }*/
        }} style={[styles.inputBoxQuote]} mt="20" justifyContent="space-between" flexDirection="row" alignItems="center">
					{authContext?.loginData?.uidtipo == "RV" &&
            newQuoteContext?.clientType == NewQuote_1.EClientType.CLIENT_NEW ? (<native_base_1.Text>{warehouseRV?.nombre || ""}</native_base_1.Text>) : (<native_base_1.Text>{warehouse?.nombre || ""}</native_base_1.Text>)}

					<native_base_1.Image source={icons_1.default.icMore} w="10" h="10"/>
				</native_base_1.Pressable>
			</native_base_1.VStack>
		</>);
};
const Product = ({ product, deleteProduct, updateProductPrice, updateProductSize }) => {
    const authContext = React.useContext(context_1.AuthContext);
    const styles = react_native_1.StyleSheet.create({
        layoutProduct: {
            marginTop: 20,
            flexDirection: "row",
            borderRadius: theme_1.default.Sizes.configRadius,
            borderWidth: 1,
            borderColor: theme_1.default.Colors.colorLightGray1,
        },
        layoutData: {
            flex: 1,
        },
        layoutProductSku: {
            flex: 1,
        },
        containerImgDelete: {
            backgroundColor: theme_1.default.Colors.colorVeryLightGray3,
            marginLeft: 10,
            padding: 6,
            borderRadius: theme_1.default.Sizes.configRadiusSm,
        },
        imgDelete: {
            width: 16,
            height: 16,
        },
        checkboxFree: {
            marginTop: 10,
        },
        layoutSize: {
            flexDirection: "column",
            alignItems: "center",
        },
        layoutPlusMinus: {
            padding: 10,
            borderColor: "black",
            borderWidth: 1,
            borderRadius: theme_1.default.Sizes.configRadius,
        },
        imgPlusMinus: {
            width: 15,
            height: 15,
        },
        txtSize: {
            paddingHorizontal: 20,
        },
    });
    const onDeletePress = () => {
        deleteProduct(product);
    };
    const [price, setPrice] = React.useState(product?.preciounit);
    const handlePriceChange = (newPrice) => {
        if (!isNaN(Number(newPrice))) {
            setPrice(newPrice);
            updateProductPrice(newPrice);
        }
    };
    React.useEffect(() => {
        setPrice(product?.preciounit);
    }, [product?.preciounit]);
    const [size, setSize] = React.useState(product?.cantidad);
    const handleSizeChange = (newSize) => {
        if (!isNaN(Number(newSize))) {
            setSize(newSize);
            updateProductSize(newSize);
        }
    };
    React.useEffect(() => {
        setSize(product?.cantidad);
    }, [product?.cantidad]);
    return (<native_base_1.HStack style={styles.layoutProduct} px={{ base: 10, md: 25 }} py={{ base: 8, md: 14 }} alignItems="center">
			<native_base_1.VStack style={styles.layoutData} alignItems="flex-start">
				<native_base_1.VStack style={styles.layoutProductSku}>
					<native_base_1.Text variant="h23">{product?.nombre || ""}</native_base_1.Text>
					<native_base_1.Text variant="body6">{`SKU ${product?.codigo ?? ""}`}</native_base_1.Text>
				</native_base_1.VStack>
				<native_base_1.HStack alignItems="center">
					<native_base_1.Input w="90" variant="h3" borderWidth={2} borderRadius={10} borderColor="colorTextPrimary" mt="2" py={3} px={3} textAlign="center" value={price ?? ""} onChangeText={handlePriceChange} isDisabled={(0, url_1.getUserTypeFromUrl)() == constants_1.UserType.RV}/>
					{Number(product?.descuento) > 0 && (<native_base_1.Text variant="body5" ml={10}>{`Desc.: ${product?.descuentoView}`}</native_base_1.Text>)}
				</native_base_1.HStack>
				{product?.preciobase && (<native_base_1.Text w="90" mt={{ base: 0, md: 2 }} variant="body4" strikeThrough textAlign="center">
						{product?.preciobase}
					</native_base_1.Text>)}
			</native_base_1.VStack>
			<native_base_1.HStack flexDirection="row" alignItems="center">
				<native_base_1.VStack style={styles.layoutSize}>
					<native_base_1.Text>Cant.</native_base_1.Text>
					<native_base_1.Input value={size ?? ""} onChangeText={handleSizeChange} w="70" variant="h3" py={4} px={4} borderWidth={2} borderRadius={10} borderColor="colorTextPrimary" textAlign="center"/>
					<native_base_1.Text variant="body5" mt="5">{`${theme_1.Str.subtotal}: ${product?.precio}`}</native_base_1.Text>
				</native_base_1.VStack>
				<native_base_1.Pressable onPress={onDeletePress} style={styles.containerImgDelete}>
					<native_base_1.Image style={styles.imgDelete} source={require("images/ic_trash.svg")} alt={theme_1.Str.alt.ic_trash}/>
				</native_base_1.Pressable>
			</native_base_1.HStack>
		</native_base_1.HStack>);
};
const AddDiscount = ({ isVisible, discounts, warehouse, warehouseRV, listShoppingCart }) => {
    const [showModal, setShowModal] = React.useState(false);
    if (!isVisible) {
        return <></>;
    }
    return (<>
			<modal_1.ModalQuoteDiscount warehouse={warehouse} warehouseRV={warehouseRV} discounts={discounts} isOpen={showModal} onClose={() => setShowModal(false)} onApplySuccess={() => {
            setShowModal(false);
            listShoppingCart();
        }}/>
			<native_base_1.View style={styles.layoutDiscount}>
				<native_base_1.Text style={[styles.txtDiscount]} variant="h23">
					{theme_1.Str.discount}
				</native_base_1.Text>
				<native_base_1.Button style={[styles.btnAddDiscount]} startIcon={<native_base_1.Image source={require("images/ic_plus")} variant="iconButtonRightSm" alt={theme_1.Str.alt.ic_plus} style={{ tintColor: theme_1.Colors.colorBtnSecondaryIcon }}/>} onPress={() => setShowModal(true)} colorScheme={theme_1.Colors.btnSecondary.name} size="sm">
					Añadir
				</native_base_1.Button>
			</native_base_1.View>
		</>);
};
const LayoutPrices = ({ shoppingCartResponse, client, newClientName, setNewClientName, listShoppingCart, setShoppingCartResponse, warehouseRV, setWarehouse, setIsLoading, }) => {
    const newQuoteContext = React.useContext(context_1.NewQuoteContext);
    const toast = (0, native_base_1.useToast)();
    const [showModal, setShowModal] = React.useState(false);
    const [quoteGenerateResponse, setQuoteGenerateResponse] = React.useState();
    const onGenerateQuotePress = () => {
        const onSuccess = (response) => {
            listShoppingCart();
            setQuoteGenerateResponse(response);
            setShowModal(true);
            if (newQuoteContext?.clientType == NewQuote_1.EClientType.CLIENT_EXISTENT) {
                newQuoteContext?.setClient(undefined);
                setShoppingCartResponse(undefined);
                setWarehouse(undefined);
            }
            else {
                setNewClientName("");
                listShoppingCart();
                setWarehouse(undefined);
            }
            console.log("setWarehouse", setWarehouse);
        };
        const onFail = (msg) => {
            listShoppingCart();
            //setShowModal(true);
            toast.show({ description: msg });
        };
        (0, services_1.doQuoteSave)({
            params: {
                cliid: newQuoteContext?.clientType == NewQuote_1.EClientType.CLIENT_EXISTENT ? client?.id : "",
                tipo: newQuoteContext?.isNewRV() == true ? "cotirvmt" : "coti",
                data: {
                    cliente: newQuoteContext?.clientType == NewQuote_1.EClientType.CLIENT_EXISTENT ? client?.nombre : newClientName,
                    comentario: "",
                    almacen: newQuoteContext?.isNewRV() == true ? warehouseRV?.codigo : undefined,
                },
            },
            callback: {
                onSuccess,
                onFail,
                onLoading: setIsLoading,
            },
        });
    };
    const onCloseModal = () => {
        setShowModal(false);
    };
    return (<>
			<modal_1.ModalQuoteGenerated isOpen={showModal} onClose={onCloseModal} quoteId={quoteGenerateResponse?.id}/>
			<native_base_1.VStack flex="1" alignItems="center" minW={{ base: "100%", xl: "200" }} mt={{ base: 25, md: 30 }} ml={{ base: 0, xl: 40 }}>
				<native_base_1.HStack style={[styles.layoutPricesLine]}>
					<native_base_1.Text style={[styles.txtPriceTitle]} variant="body23">
						{theme_1.Str.subtotal}
					</native_base_1.Text>
					<native_base_1.Text style={[styles.txtPriceText]} variant="body23">
						{shoppingCartResponse?.subtotal ?? ""}
					</native_base_1.Text>
				</native_base_1.HStack>
				<native_base_1.HStack style={[styles.layoutPricesLine]} marginTop={{ base: 15, md: 20 }}>
					<native_base_1.Text style={[styles.txtPriceTitle]} variant="body23">
						IGV (18%)
					</native_base_1.Text>
					<native_base_1.Text style={[styles.txtPriceText]} variant="body23">
						{shoppingCartResponse?.igv ?? ""}
					</native_base_1.Text>
				</native_base_1.HStack>
				{false && Number(shoppingCartResponse?.sumadescuento) > 0 && (<native_base_1.HStack style={[styles.layoutPricesLine]} marginTop={{ base: 15, md: 20 }}>
						<native_base_1.Text style={[styles.txtPriceTitle]} variant="body23">
							{theme_1.Str.discount}
						</native_base_1.Text>
						<native_base_1.Text style={[styles.txtPriceText]} variant="body23">
							{shoppingCartResponse?.porcentajedescuento ?? ""}
						</native_base_1.Text>
						<native_base_1.Text style={[styles.txtPriceText]} variant="body23">
							{shoppingCartResponse?.sumadescuento ?? ""}
						</native_base_1.Text>
					</native_base_1.HStack>)}
				<native_base_1.HStack style={[styles.layoutPricesLine, styles.layoutPricesTotal]} marginTop={{ base: 15, md: 30 }}>
					<native_base_1.Text style={[styles.txtPriceTitle, styles.txtPriceTitleTotal]} variant="h23">
						Total
					</native_base_1.Text>
					<native_base_1.Text style={[styles.txtPriceText]} variant="h23">
						{shoppingCartResponse?.total}
					</native_base_1.Text>
				</native_base_1.HStack>
				<native_base_1.Button style={styles.btnGenerateQuote} onPress={onGenerateQuotePress} w={{ base: "100%", md: "auto" }} _text={{
            textTransform: "uppercase",
        }}>
					{theme_1.Str.generateQuote}
				</native_base_1.Button>
			</native_base_1.VStack>
		</>);
};
const styles = react_native_1.StyleSheet.create({
    svContainer: {
        width: "100%",
    },
    svContainerContent: {
        alignItems: "center",
    },
    layoutContainer: {
        width: "100%",
        flexDirection: "row",
        flexWrap: "wrap",
    },
    boxQuote: {
        flex: 1,
        marginTop: 30,
        backgroundColor: "white",
        borderRadius: theme_1.default.Sizes.configRadius,
    },
    inputBoxQuote: {
        minHeight: theme_1.Sizes.inputMinHeight,
        paddingHorizontal: theme_1.Sizes.inputPaddingHorizontal,
        paddingTop: theme_1.Sizes.inputPaddingVertical,
        paddingBottom: theme_1.Sizes.inputPaddingVertical,
        borderColor: "black",
        borderWidth: 2,
        borderRadius: theme_1.default.Sizes.inputRadius,
    },
    txtClient: {
        flex: 1,
    },
    radioGroupClient: {
        flexDirection: "row",
    },
    radioNew: {
        marginEnd: 20,
    },
    radioExisting: {},
    inputClient: {
        marginTop: 20,
    },
    txtStock: {
        marginTop: 25,
    },
    layoutProducts: {
        marginTop: 25,
        flexDirection: "row",
        alignItems: "center",
    },
    txtProducts: {
        marginEnd: 30,
    },
    btnAddProduct: {
        marginEnd: 30,
    },
    containerImgEdit: {
        padding: 10,
        backgroundColor: theme_1.default.Colors.colorVeryLightGray1,
        borderRadius: 10,
    },
    imgEdit: {
        width: 20,
        height: 20,
    },
    layoutDiscount: {
        marginTop: 20,
        flexDirection: "row",
        alignItems: "center",
    },
    txtDiscount: {
        marginEnd: 30,
    },
    btnAddDiscount: {},
    layoutPricesLine: {
        width: "100%",
        flexDirection: "row",
        alignItems: "center",
    },
    txtPriceTitle: {
        flex: 1,
    },
    txtPriceText: {
        minWidth: 100,
        textAlign: "right",
    },
    layoutPricesTotal: {
        paddingBottom: 20,
        borderBottomColor: "black",
        borderBottomWidth: 1.5,
    },
    txtPriceTitleTotal: {
        textTransform: "uppercase",
    },
    btnGenerateQuote: {
        marginTop: 30,
        marginBottom: 20,
    },
});
exports.name = "NewQuoteName";
exports.default = NewQuote;
